const appLS = {
    companyKey: 'company_key',
    appLanguage: 'app_language',
    user: 'user',
    redirectUrl: 'redirect_url'
}
export default appLS;